class HmqrAscoreDictionaryUrl {
    constructor(hostname, path = '/api') {
        this._api = hostname + path
    }
    get query (){
        return this._api + '/meteringquery/gethmqrdidps'
    }
    get handle (){
        return this._api + '/meteringoperation/operationdidps'
    }
}
class HmqrAscoreUrl {
    constructor(hostname, path = '/api') {
        this._api = hostname + path
        this._hostname = hostname
        this._path = path
    }

    get query (){
        return this._api + '/meteringquery/gethmqrs'
    }
    get handle (){
        return this._api + '/meteringoperation/operationascore'
    }
    get HmqrAscoreDictionaryUrl () {
        return new HmqrAscoreDictionaryUrl(this._hostname, this._path)
    }
}

export default HmqrAscoreUrl
